import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AdminSession, Session } from '@core/models/Session';
import { SessionService } from '@core/services/session.service';
import { StorageService } from '@core/services/storage.service';
@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private session: Session;
  private adminSession: AdminSession;
  constructor(
    private _router: Router,
    private _storage: StorageService,
    private _session: SessionService) {
  }
  async canActivate(): Promise<boolean> {
    const jwt: string = await this._storage.get('jwt');
    if (!jwt) {
      await this._router.navigate(['/login']);
      return false;
    }
    this.session = this._session.getSession();
    this.adminSession = this._session.getAdminSession();
    if (!this.session.policyChecked && !this.adminSession.policyChecked) {
      await this._router.navigate(['/', 'policy']);
      return false;
    }
    return true;
  }
}
